import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { PaymentStatus, PaynowService } from '../../api/paynowService';

interface PaymentStatusChipProps {
  status: PaymentStatus;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
}

const PaymentStatusChip: React.FC<PaymentStatusChipProps> = ({
  status,
  size = 'small',
  variant = 'filled'
}) => {
  const color = PaynowService.getStatusColor(status);
  const displayText = PaynowService.getStatusDisplayText(status);

  const getTooltipText = (status: PaymentStatus) => {
    switch (status) {
      case 'PENDING':
        return 'Payment has been created but not yet initiated';
      case 'INITIATED':
        return 'Payment has been initiated and is being processed';
      case 'AWAITING_DELIVERY':
        return 'Payment received; awaiting delivery confirmation on Paynow';
      case 'DELIVERED':
        return 'Payment has been delivered but not yet confirmed';
      case 'PAID':
        return 'Payment has been successfully completed';
      case 'CANCELLED':
        return 'Payment was cancelled';
      case 'FAILED':
        return 'Payment failed due to an error or insufficient funds';
      case 'DISPUTED':
      case 'DISPUTE':
        return 'Payment is under dispute and being investigated';
      case 'REFUNDED':
        return 'Payment was refunded to the customer';
      default:
        return displayText;
    }
  };

  return (
    <Tooltip title={getTooltipText(status)} arrow>
      <Chip
        label={displayText}
        color={color}
        size={size}
        variant={variant}
        sx={{
          fontWeight: 600,
          '& .MuiChip-label': {
            px: 1
          }
        }}
      />
    </Tooltip>
  );
};

export default PaymentStatusChip;
